import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { getUserSupportTicketByUser } from "../../common/endpoints";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const getUserSupportTicketSummary = createApi(getUserSupportTicketByUser, "GET");

const getUserSupportTicketSummarySlice = createSlice({
  name: "getUserSupportTicketSummary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserSupportTicketSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserSupportTicketSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.data = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(getUserSupportTicketSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getUserSupportTicketSummarySlice.reducer;
